/**
 *
 * @returns {string} - Returns the main domain like "localhost" or "geslub.com" (without subdomains)
 */
export const getMainHostName = (): string => {
  const domain = window.location.hostname;
  return domain.split(".").slice(-2).join(".");
};
